import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BaseChartDirective, Color} from 'ng2-charts';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';

@Component({
  selector: 'graph-ng2charts',
  templateUrl: './graph-ng2charts.component.html',
  styleUrls: ['./graph-ng2charts.component.scss']
})
export class GraphNg2chartsComponent {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  @Input() chartOptions: ChartOptions;
  @Input() chartLabels: String[];
  @Input() chartType: ChartType;
  @Input() chartLegend: boolean;
  @Input() chartData: ChartDataSets[];
  @Input() chartColors: Color[];
  @Output() chartClick  = new EventEmitter();

  onClick(e) {
    this.chartClick.emit(e);
  }

}
